import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function ServicesGrid({ heading = true }) {
  return (
    <section data-testid="services-grid" className="py-24 md:py-32 bg-teh-bg">
      <div className="teh-container">
        {heading && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
            <div className="lg:col-span-5">
              <p className="teh-overline">Our Divisions</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 text-teh-deep leading-[1.05] tracking-tight">
                One enterprise.
                <br />
                <span className="italic text-teh-green">Six ways</span> we care.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end">
              <p className="text-lg text-teh-muted leading-relaxed">
                Operated under a centralized management structure, our service lines work
                together — so a single referral can unlock home care, a ride to dialysis,
                in-home therapy, and the equipment a family needs to thrive at home.
              </p>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const isExternal = !!s.external_url;
            const Wrapper = isExternal ? "a" : Link;
            const wrapperProps = isExternal
              ? { href: s.external_url, target: "_blank", rel: "noopener noreferrer" }
              : { to: `/services/${s.slug}` };
            return (
              <Wrapper
                key={s.slug}
                {...wrapperProps}
                data-testid={`service-card-${s.slug}`}
                className="group relative flex flex-col p-8 bg-white border border-teh-navy/10 rounded-2xl hover:shadow-2xl hover:shadow-teh-navy/5 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
              >
                <div className="flex items-start justify-between mb-10">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${s.color}15`, color: s.color }}
                  >
                    <Icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                  <div className="flex items-center gap-2">
                    {isExternal && (
                      <span className="text-[10px] uppercase tracking-[0.18em] font-semibold px-2 py-1 bg-teh-green/10 text-teh-green rounded-full">
                        Visit site
                      </span>
                    )}
                    <span className="font-serif text-3xl text-teh-navy/20">
                      0{i + 1}
                    </span>
                  </div>
                </div>

                <h3 className="font-serif text-2xl text-teh-deep leading-tight">
                  {s.name}
                </h3>
                <p className="mt-3 text-sm text-teh-muted leading-relaxed flex-grow">
                  {s.short}
                </p>

                <div className="mt-8 flex items-center justify-between pt-6 border-t border-teh-navy/5">
                  <span className="text-xs uppercase tracking-[0.18em] text-teh-green font-semibold">
                    {isExternal ? "Visit the site" : "Learn more"}
                  </span>
                  <ArrowUpRight
                    className="w-5 h-5 text-teh-navy group-hover:text-teh-green group-hover:rotate-45 transition-all duration-300"
                    strokeWidth={1.5}
                  />
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
